import React from 'react';
import {
  AutocompleteInput,
  UPDATE,
  showNotification as showNotificationAction,
  translate as i18n,
  SimpleForm,
} from 'admin-on-rest';
import { connect } from 'react-redux';
import { Field, getFormValues } from 'redux-form';
import { getPossibleReferences } from 'admin-on-rest/lib/reducer/admin/references/possibleValues';
import { List, ListItem, Card } from 'material-ui';
import { keys, get } from 'lodash';
import References from './References';

import { kunal } from '../client';
import kunalClient from '../client/kunalClient';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:4042/api';
const restClient = kunalClient(API_BASE_URL, kunal);

const referenceSource = (resource, source) => `${resource}@${source}`;

const TierField = ({ defaultValue, source, resource, products, name, filter, translate, tier, category, ...props }) => (
  <Field
    name={name}
    component={(p) => (
      <AutocompleteInput
        {...props}
        {...p}
        options={{ menuStyle: { maxHeight: '200px' }, fullWidth: true }}
        label={translate(props.searchLabel || 'searchNewValue')}
        choices={products.filter((prod) => filterFn(prod, category))}
        optionText="internalName"
      />
    )}
  />
);

export const TierForm = (props) => (
  <Card>
    {(props.filterByMarket ? props.choices.markets.filter((m) => m._id === props.record.market._id) : props.choices.markets).map((market) => (
      <List>
        <ListItem
          primaryText={market.countryCode}
          primaryTogglesNestedList
          nestedItems={[
            <fieldset style={{ marginBottom: '1em' }}>
              <legend>{props.translate('resources.tieredProducts.red')}</legend>
              <fieldset style={{ marginBottom: '1em' }}>
                <legend>{props.translate('resources.tieredProducts.t1')}</legend>
                <strong>{props.translate(props.valueLabel || 'currentValue')}: {get(market, 'tieredProducts.red.t1')}</strong>
                <TierField
                  {...props}
                  name={`${props.prefix !== undefined ? props.prefix : `markets.${market._id}.`}tieredProducts.red.t1`}
                  defaultValue={get(market, 'tieredProducts.red.t1')}
                  tier="t1"
                  category="Red Wine"
                />
              </fieldset>
              <fieldset style={{ marginBottom: '1em' }}>
                <legend>{props.translate('resources.tieredProducts.t2')}</legend>
                <strong>{props.translate(props.valueLabel || 'currentValue')}: {get(market, 'tieredProducts.red.t2')}</strong>
                <TierField
                  {...props}
                  name={`${props.prefix !== undefined ? props.prefix : `markets.${market._id}.`}tieredProducts.red.t2`}
                  defaultValue={get(market, 'tieredProducts.red.t2')}
                  tier="t2"
                  category="Red Wine"
                />
              </fieldset>
              <fieldset style={{ marginBottom: '1em' }}>
                <legend>{props.translate('resources.tieredProducts.t3')}</legend>
                <strong>{props.translate(props.valueLabel || 'currentValue')}: {get(market, 'tieredProducts.red.t3')}</strong>
                <TierField
                  {...props}
                  name={`${props.prefix !== undefined ? props.prefix : `markets.${market._id}.`}tieredProducts.red.t3`}
                  defaultValue={get(market, 'tieredProducts.red.t3')}
                  tier="t3"
                  category="Red Wine"
                />
              </fieldset>
            </fieldset>,
            <fieldset style={{ marginBottom: '1em' }}>
              <legend>{props.translate('resources.tieredProducts.white')}</legend>
              <fieldset style={{ marginBottom: '1em' }}>
                <legend>{props.translate('resources.tieredProducts.t1')}</legend>
                <strong>{props.translate(props.valueLabel || 'currentValue')}: {get(market, 'tieredProducts.white.t1')}</strong>
                <TierField
                  {...props}
                  name={`${props.prefix !== undefined ? props.prefix : `markets.${market._id}.`}tieredProducts.white.t1`}
                  defaultValue={get(market, 'tieredProducts.white.t1')}
                  tier="t1"
                  category="White & Rosé Wine"
                />
              </fieldset>
              <fieldset style={{ marginBottom: '1em' }}>
                <legend>{props.translate('resources.tieredProducts.t2')}</legend>
                <strong>{props.translate(props.valueLabel || 'currentValue')}: {get(market, 'tieredProducts.white.t2')}</strong>
                <TierField
                  {...props}
                  name={`${props.prefix !== undefined ? props.prefix : `markets.${market._id}.`}tieredProducts.white.t2`}
                  defaultValue={get(market, 'tieredProducts.white.t2')}
                  tier="t2"
                  category="White & Rosé Wine"
                />
              </fieldset>
              <fieldset style={{ marginBottom: '1em' }}>
                <legend>{props.translate('resources.tieredProducts.t3')}</legend>
                <strong>{props.translate(props.valueLabel || 'currentValue')}: {get(market, 'tieredProducts.white.t3')}</strong>
                <TierField
                  {...props}
                  name={`${props.prefix !== undefined ? props.prefix : `markets.${market._id}.`}tieredProducts.white.t3`}
                  defaultValue={get(market, 'tieredProducts.white.t3')}
                  tier="t3"
                  category="White & Rosé Wine"
                />
              </fieldset>
            </fieldset>,
            <fieldset style={{ marginBottom: '1em' }}>
              <legend>{props.translate('resources.tieredProducts.rose')}</legend>
              <fieldset style={{ marginBottom: '1em' }}>
                <legend>{props.translate('resources.tieredProducts.t1')}</legend>
                <strong>{props.translate(props.valueLabel || 'currentValue')}: {get(market, 'tieredProducts.rose.t1')}</strong>
                <TierField
                  {...props}
                  name={`${props.prefix !== undefined ? props.prefix : `markets.${market._id}.`}tieredProducts.rose.t1`}
                  defaultValue={get(market, 'tieredProducts.rose.t1')}
                  tier="t1"
                  category="White & Rosé Wine"
                />
              </fieldset>
              <fieldset style={{ marginBottom: '1em' }}>
                <legend>{props.translate('resources.tieredProducts.t2')}</legend>
                <strong>{props.translate(props.valueLabel || 'currentValue')}: {get(market, 'tieredProducts.rose.t2')}</strong>
                <TierField
                  {...props}
                  name={`${props.prefix !== undefined ? props.prefix : `markets.${market._id}.`}tieredProducts.rose.t2`}
                  defaultValue={get(market, 'tieredProducts.rose.t2')}
                  tier="t2"
                  category="White & Rosé Wine"
                />
              </fieldset>
              <fieldset style={{ marginBottom: '1em' }}>
                <legend>{props.translate('resources.tieredProducts.t3')}</legend>
                <strong>{props.translate(props.valueLabel || 'currentValue')}: {get(market, 'tieredProducts.rose.t3')}</strong>
                <TierField
                  {...props}
                  name={`${props.prefix !== undefined ? props.prefix : `markets.${market._id}.`}tieredProducts.rose.t3`}
                  defaultValue={get(market, 'tieredProducts.rose.t3')}
                  tier="t3"
                  category="White & Rosé Wine"
                />
              </fieldset>
            </fieldset>,
            <fieldset style={{ marginBottom: '1em' }}>
              <legend>{props.translate('resources.tieredProducts.sparkling')}</legend>
              <fieldset style={{ marginBottom: '1em' }}>
                <legend>{props.translate('resources.tieredProducts.t1')}</legend>
                <strong>{props.translate(props.valueLabel || 'currentValue')}: {get(market, 'tieredProducts.sparkling.t1')}</strong>
                <TierField
                  {...props}
                  name={`${props.prefix !== undefined ? props.prefix : `markets.${market._id}.`}tieredProducts.sparkling.t1`}
                  defaultValue={get(market, 'tieredProducts.sparkling.t1')}
                  tier="t1"
                  category="Sparkling Wine"
                />
              </fieldset>
              <fieldset style={{ marginBottom: '1em' }}>
                <legend>{props.translate('resources.tieredProducts.t2')}</legend>
                <strong>{props.translate(props.valueLabel || 'currentValue')}: {get(market, 'tieredProducts.sparkling.t2')}</strong>
                <TierField
                  {...props}
                  name={`${props.prefix !== undefined ? props.prefix : `markets.${market._id}.`}tieredProducts.sparkling.t2`}
                  defaultValue={get(market, 'tieredProducts.sparkling.t2')}
                  tier="t2"
                  category="Sparkling Wine"
                />
              </fieldset>
              <fieldset style={{ marginBottom: '1em' }}>
                <legend>{props.translate('resources.tieredProducts.t3')}</legend>
                <strong>{props.translate(props.valueLabel || 'currentValue')}: {get(market, 'tieredProducts.sparkling.t3')}</strong>
                <TierField
                  {...props}
                  name={`${props.prefix !== undefined ? props.prefix : `markets.${market._id}.`}tieredProducts.sparkling.t3`}
                  defaultValue={get(market, 'tieredProducts.sparkling.t3')}
                  tier="t3"
                  category="Sparkling Wine"
                />
              </fieldset>
            </fieldset>,
          ]}
        />
      </List>
    ))}
  </Card>
);

const filterFn = (product, category) => {
  const enTitle = product.category && product.category.title.find((t) => t.lang === 'en');
  return product.category.mainCategory === 'drink' && enTitle && enTitle.content === category;
};

const onSave = ({ markets, record, resource, showNotification }) => {
  const updatedMarkets = keys(record.markets);
  updatedMarkets.forEach((market) => {
    const oldMarket = markets.find((c) => (c._id === market));
    restClient(UPDATE, resource, { id: market, data: { ...oldMarket, ...record.markets[market] } })
      .then(() => {
        showNotification('Updated');
      })
      .catch((e) => {
        console.error(e);
        showNotification('Error: not updated', 'warning');
      });
  });
};

const Tiered = (props) => (
  <SimpleForm save={() => onSave(props)}>
    <References {...props} references={[{ name: 'markets' }, { name: 'products', filter: { mainCategory: 'drink' } }]}>
      <TierForm {...props} />
    </References>
  </SimpleForm>
);

const selector = getFormValues('record-form');
const mapStateToProps = (state, props) => ({
  products: getPossibleReferences(
    state,
    referenceSource(props.resource, 'products'),
    'products',
  ),
  markets: getPossibleReferences(
    state,
    referenceSource(props.resource, 'markets'),
    'markets',
  ),
  record: selector(state),
});

export const TierFormConnected = connect(mapStateToProps, { showNotification: showNotificationAction })(i18n(TierForm));
export default connect(mapStateToProps, { showNotification: showNotificationAction })(i18n(Tiered));
